angular
    .module('editingCenterModule')
    .service('fusionApiService', [
        'trsHttpService',
        '$q',
        function(trsHttpService, $q) {
            let commonParams = {
                serviceid: 'mlf_fusion',
                dataSource: 'wcm',
            };

            return {
                fusionAll: requestData,
                getFusionStatus: requestData,
                unLock: requestData,
                getServerTime: requestData,
            };

            /**
             * [dealParams 公共的参数适配方法]
             *
             * @param   {[type]}  params  [params description]
             *
             * @return  {[type]}          [return description]
             */
            function dealParams(params) {
                return params;
            }

            /**
             * [dealData 适配响应数据]
             *
             * @param   {[type]}  data  [data description]
             *
             * @return  {[type]}        [return description]
             */
            function dealData(data) {
                return data;
            }

            /**
             * [requestData 统一的请求方法，默认请求方法]
             *
             * @param   {[type]}  params  [params description]
             *
             * @return  {[type]}          [return description]
             */
            function requestData(params) {
                let deffer = $q.defer();
                let requestParams = angular.extend({}, commonParams, dealParams(params));
                let dataSource = requestParams.dataSource ? requestParams.dataSource : 'bigData';
                let httpMethod = requestParams.httpMethod ? requestParams.httpMethod : 'post';
                if (requestParams.dataSource) {
                    delete requestParams.dataSource;
                }
                if (requestParams.httpMethod) {
                    delete requestParams.httpMethod;
                }
                let url = dataSource === 'bigData' ? trsHttpService.getBigDataRootUrl() : trsHttpService.getWCMRootUrl();
                trsHttpService.httpServer(url, requestParams, httpMethod).then(
                    function(data) {
                        let result = dealData(data);
                        deffer.resolve(result);
                    },
                    function(data) {
                        deffer.reject(data);
                    }
                );
                return deffer.promise;
            }
        },
    ])
    .value('fusionParams', {
        // 操作指定渠道所有稿件的参数
        fusionAllParams: {
            methodname: 'doActionOnMediaTypes',
            oprType: '',
            actionKey: '',
            mediaTypes: '',
            OprTime: '',
        },
        // 查询融合审签任务结果的参数
        fusionStatusParams: {
            methodname: 'getTaskStatus',
            taskId: '',
        },
        unLockParams: {
            methodname: 'forcedUnLockTask',
            taskId: '',
        },
        serverTimeParams: {
            methodname: 'getServiceTime',
            httpMethod: 'get'
        },
        fusionTaskStatus: {
            finish: '200',
            running: '-1',
            deleted: '404'
        }
    });
